import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {CustomizeHttpUrlGenerator} from '../../../../../store/core/url/customizeHttpUrlGenerator';
import {AbstractActionService} from '../../../../core/service/v2/service/action/abstractAction.service';
import {PayloadWithId} from '../../../../core/service/payload/payloadWithId';
import {PartnerGetSimilarPartnersResult} from './result/partnerGetSimilarPartners.result';
import {PartnerSimilarPartnersConverter} from './result/partnerSimilarPartners.converter';

@Injectable()
export class PartnerGetSimilarPartnersActionService extends AbstractActionService<PayloadWithId, PartnerGetSimilarPartnersResult> {

    public constructor(customizeHttpUrlGenerator: CustomizeHttpUrlGenerator,
                       httpClient: HttpClient,
                       private partnerSimilarPartnersConverter: PartnerSimilarPartnersConverter) {
        super('Partner', 'get-similar-partners', customizeHttpUrlGenerator, httpClient);
    }

    protected buildResponse(response: PartnerGetSimilarPartnersResult): PartnerGetSimilarPartnersResult {
        const result = new PartnerGetSimilarPartnersResult();
        response.partners.forEach((partner) => {
            result.partners.push(this.partnerSimilarPartnersConverter.convert(partner));
        });
        return result;
    }
}
